export default __webpack_public_path__ + "static/Manish-Panjiar-3598098ab73722f41590927dafffa792.jpg";